import { axios } from 'lib'
import { useMutation } from 'react-query'
import { toast } from 'react-toastify'

const updateOrderParameter = (data: any): Promise<any> => {
  return axios.put(`/parameters/order/${data.orderId}`, data)
}

export function useUpdateOrderParameter() {
  return useMutation(updateOrderParameter, {
    onSuccess: () => {
      toast.success('Cadastrado com sucesso!')
    },
    onError: (error: unknown) => {
      console.error(error)
      toast.error('Não foi possível cadastrar!')
    }
  })
}
